const slugify = require("./slugify");

function extractAnchors(_n) {
	const anchors = [];
	if (_n.attributes) {
		if (
			(_n.type === "node--heading" && _n.attributes.field_heading_type === "h2") ||
			_n.type === "node--accordion_tab" ||
			_n.type === "node--highlight"
		) {
			let anchor =
				(_n.type === "node--accordion_tab" &&
					_n.attributes &&
					_n.attributes.field_include_in_anchor_nav) ||
				_n.type !== "node--accordion_tab"
					? {
							id: slugify(_n.attributes.title),
							title: _n.attributes.title,
					  }
					: null;
			if (anchor) {
				anchors.push(anchor);
			}
		} else if (_n.type === "node--text") {
			const matches = _n.attributes.body.value.match(/<h2[^>]*>(.*?)<\/h2>/g);
			if (matches) {
				for (const match of matches) {
					let title = match.replace(/<\/?h2[^>]*>/g, "");
					title = title.replace(/&nbsp;/g, " ");
					const id = slugify(title);
					anchors.push({ id, title });
				}
			}
		}
	}
	return anchors;
}

module.exports = function extractAnchorsData(nodes) {
	let data = [];
	for (const _n of nodes) {
		if (_n.type === "node--row") {
			["field_row_column_1", "field_row_column_2", "field_row_column_3"].forEach(
				(field_column_name) => {
					if (
						_n.relationships &&
						_n.relationships[field_column_name] &&
						_n.relationships[field_column_name].data &&
						_n.relationships[field_column_name].data.length > 0
					) {
						for (const _c of _n.relationships[field_column_name].data) {
							data = data.concat(extractAnchors(_c));
						}
					}
				}
			);
		} else {
			data = data.concat(extractAnchors(_n));
		}
	}
	return data;
};
